import React from 'react';
import './ValidationOutcome.css';
import { useNavigate, useParams } from 'react-router-dom';
import CustomButton from '../CustomButton/CustomButton';
import PhoneFailureImage from '../../assets/images/phone_failure.svg';

interface ValidationOutcomeProps {
  data?: any;
}

function ValidationOutcome({
  data,
}: ValidationOutcomeProps) {
  const releases = [
    {
      title: 'Digital Employee Digital Credential',
      description: 'The issuance of verifiable digital credentials for public employees is enabled...',
      from: 'HM Courts & Tribunals Service',
      date: '02 Jun 2025',
    },
    {
      title: 'Physical Access Verification',
      description: 'Added support for door opening via digital credential...',
      from: 'HM Courts & Tribunals Service',
      date: '28 May 2025',
    },
    {
      title: 'Activity Log and Last Entry',
      description: 'User activity within the system is recorded...',
      from: 'HM Courts & Tribunals Service',
      date: '14 Feb 2024',
    },
    {
      title: 'Institutional Login',
      description: 'Integration with the public services portal...',
      from: 'HM Courts & Tribunals Service',
      date: '28 May 2023',
    },
    {
      title: 'Physical Access Verification',
      description: 'Added support for door opening via digital credential...',
      from: 'HM Courts & Tribunals Service',
      date: '28 May 2025',
    },
  ];

  const navigate = useNavigate();
  const { status } = useParams();

  const success = !(!status || !data || status !== 'success');
  const message = 'The QR code has expired or the credential has not been able to be validated due to an error during the process';

  let credentialSubject;
  if (data) {
    credentialSubject = data.data.credentialsPresentedList[0]
      .verifiableCredentialsDecoded.vc.credentialSubject;
  }

  return (
    <div>
      {success && (
        <div>
          <img
            src="/genericBackground.svg"
            alt="genericBackground"
            style={{
              position: 'absolute', top: 0, left: 0, objectFit: 'cover', width: '100vw', height: '100vh', zIndex: -1,
            }}
          />

          <nav className="navigation">
            {/* Logo aligned left */}
            <img src="/whiteLogo.svg" alt="DigitalGov Logo" className="logoWhite" />

            <div className="nav-wrapper">
              <a href="/" className="nav-link nav-link-active">Home</a>
              <span className="arrow">›</span>
              <span className="nav-link">About</span>
              <span className="arrow">›</span>
              <span className="nav-link">Features</span>
              <span className="arrow">›</span>
              <span className="nav-link">Services</span>

              <div className="nav-spacer" />

              <div className="logout-text">
                <a href="/">
                  Log out
                  {' '}
                  <img src="/userLogo.svg" alt="userLogo" className="user-icon" />
                </a>
              </div>
            </div>
          </nav>

          {/* Greeting */}
          <section className="greeting-validation">
            <h1>
              Hello again,
              {' '}
              {credentialSubject.givenName}
              {' '}
              {credentialSubject.familyName}
            </h1>
          </section>

          {/* Main Layout */}
          <div className="layout">
            {/* Sidebar */}
            <aside className="sidebar">
              <div className="search-wrapper">
                <input type="text" placeholder="Search" className="search-input" />
                <img src="/searchIcon.svg" alt="Search" className="search-icon" />
              </div>
              <div className="filters">
                {/*
            eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label>Document type</label>
                <div className="filter-tags">
                  <button type="button" className="tag active">Corporate report</button>
                  <button type="button" className="tag">FOI Release</button>
                  <button type="button" className="tag">Transparency data</button>
                </div>
                {/*
            eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label>Organisation</label>
                <div className="select-wrapper">
                  <select className="custom-select">
                    <option>Choose Organisation</option>
                    <option>HM Courts</option>
                    <option>Ministry of Justice</option>
                  </select>
                </div>
              </div>
            </aside>

            {/* Content */}
            <section className="content">
              <div className="content-header">
                <h2>
                  {releases.length}
                  {' '}
                  Releases
                </h2>
                <div className="select-wrapper">
                  <select className="custom-select-sort">
                    <option>Sort by</option>
                    <option>Newest</option>
                    <option>Oldest</option>
                  </select>
                </div>
              </div>

              {releases.map((release, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index} className="release">
                  <h3>{release.title}</h3>
                  <p>{release.description}</p>
                  <div className="meta">
                    From:
                    {release.from}
                    {' '}
                    • Updated:
                    {release.date}
                  </div>
                </div>
              ))}
            </section>
          </div>
        </div>
      )}
      {!success && (
      <div className="page-container">
        <section className="page-container__section">
          <h2 className="page-container__section_header">{message}</h2>
          <img
            alt="Failure"
            src={PhoneFailureImage}
            className="page-container__section_image"
          />
          <CustomButton
            handleClick={() => navigate('/')}
            text="Try it again"
            showArrow={false}
          />
        </section>
      </div>
      )}
    </div>

  );
}

ValidationOutcome.defaultProps = {
  data: undefined,
};

export default ValidationOutcome;
